<template>
    
    <div>
        <h3 class="text-center main-sub-title">selected element</h3>
        <h2 class="text-center main-title">Vertical Divider</h2>

        <div class="preview-box" :style="{width : previewBoxWidth}">
        </div>

    </div>

</template>

<script>
export default {
    name: 'VerticalDivider',

    data() {
        return {

        }
    },
    computed:{
        // access settings from Weebly to display all correct
        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        // preview width box
        previewBoxWidth() {
            return this.$store.state.previewBoxWidth
        },

        // device Styles
        deviceStylesSetttings() {
            return this.$store.state.deviceStyles
        }
    },
    mounted() {
        // show save button
        this.$store.state.showSaveBtn = true

        // show settings
        this.$store.state.showSettingsBar = true

        // add class active to preview window for later use in getting the innerHTML - done via Topbar element
        document.querySelector('.preview-box').classList.add('active')
    }
}
</script>

<style lang="less">

</style>





// WEBPACK FOOTER //
// src/components/elements/VerticalDivider.vue